import { BaseDto } from '@/core';

export class ConsultResponseV3SendMessageDto extends BaseDto<
  ConsultResponseV3SendMessageDto
> {
  message?: string;
  googleMeetUrl?: string;
}
